<template>
  <button v-if="handleDownload" v-bind="$attrs" class="download-button" :disabled="disabled" @click="handleDownload(os, release)">
    <img v-if="os === 'mac'" src="/icons/mac.svg" alt="Mac Logo" class="download-button-icon" />
    <img v-else src="/icons/windows.svg" alt="Windows Logo" class="download-button-icon" />
    {{ os === 'mac' ? 'Mac download' : 'PC download' }}
  </button>
</template>

<script setup lang="ts">
import { ClientRelease } from '@/types'
import detectOS from '@/utils/detectOS'

defineProps<{
  handleDownload: (platform: string, release: ClientRelease) => void
  release: ClientRelease
  disabled?: boolean
}>()

const os = detectOS()
</script>

<style lang="scss" scoped>
.download-button {
  width: 200px;
  background-color: var(--color-accent-primary);
  font-family: $font-family-pilat-bold;
  font-weight: 700;
  height: 48px;
  padding: 0 $spacer-3;
  border-radius: 8px;
  gap: $spacer-2;
  justify-content: center;
  align-items: center;
}

.download-button-icon {
  margin-bottom: $spacer-1;
}
</style>
